import React from 'react'
import type {
  InterviewQuestionOptionsResource,
  InterviewQuestionValidationsResource,
} from '@entities/api/Interview'
import { RegisterOptions, useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  required: boolean
  options?: InterviewQuestionOptionsResource | null
  validations?: InterviewQuestionValidationsResource | null
}

const InputText: React.FC<Props> = ({ prefix, itemName, required, options, validations }) => {
  const { register } = useFormContext()
  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const rules: RegisterOptions = {
    required: required && `${errorPrefix}回答を入力してください`,
  }

  if (validations?.minlength) {
    rules.minLength = {
      value: validations.minlength,
      message: `${errorPrefix}${validations.minlength}文字以上入力してください`,
    }
  }
  if (validations?.maxlength) {
    rules.maxLength = {
      value: validations.maxlength,
      message: `${errorPrefix}${validations.maxlength}文字以内で入力してください`,
    }
  }

  return (
    <div className="row justify-content-center pb-4">
      <div className="col input-group">
        <input
          ref={register(rules)}
          type="text"
          name={`${prefix}.value`}
          className="form-control border border-light bg-light"
          placeholder={options?.placeholder ? options.placeholder : undefined}
          aria-describedby={options?.unit && `${prefix}_value`}
        />
        {options?.unit && (
          <div className="input-group-append">
            <span id={`${prefix}_value`} className="input-group-text border-light bg-light">
              {options.unit}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default InputText
